export default __webpack_public_path__ + "static/media/element_78.3009b6a1.avif";